import React, { useEffect, useState } from 'react';
// import useUser from '../hooks/useUser';
import { useUser } from '../hooks/UserProvider';

const AuthProtected = ({ children }) => {
  const { userData, error } = useUser();
  const [isPhone, setIsPhone] = useState(true);

  useEffect(() => {
    const checkPhone = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      const lowerUserAgent = userAgent.toLowerCase();

      // Разрешаем только телефоны
      if (/iphone|ipod|android.*mobile|windows phone|blackberry/.test(lowerUserAgent)) {
        setIsPhone(true);
      } else {
        setIsPhone(false);
      }
    };

    checkPhone();
  }, []);

  if (!isPhone) {
    return (
      <div className='AuthError'>
        <h2>Access allowed only from a mobile phone 📱</h2>
      </div>
    );
  }

  if (error) {
    return (
      <div className='AuthError'>
        <h2>{error}</h2>
      </div>
    );
  }

  if (!userData) {
    return <div>Loading...</div>;
  }

  return children;
};

export default AuthProtected;